document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('content_storage')) {
        function toggle_content_storage(element) {
            const icon_arrow = element.querySelector('.icon');
            const content = element.nextElementSibling;
            
            icon_arrow.classList.toggle('icon--arrow_up');
            icon_arrow.classList.toggle('icon--arrow_down');

            if (content.style.display === 'block') {
                content.style.display = 'none';
            } else {
                content.style.display = 'block';
            }
        }

        const category_titles = document.querySelectorAll('.category_title');
        category_titles.forEach((el) => {
            el.addEventListener('click', () => {
                toggle_content_storage(el);
            });
        });

        const topic_titles = document.querySelectorAll('.topic_title');
        topic_titles.forEach((el) => {
            el.addEventListener('click', () => {
                toggle_content_storage(el);
            });
        });

        // Search
        const search_field = document.getElementById('content_storage_search');
        search_field.addEventListener('input', () => {
            const search_term = search_field.value.toLowerCase();
            const el_data_text = document.querySelectorAll("[data-text]");

            if (search_term == '') {
                const classes = ['matching', 'topic_content', 'topic_title', 'category_content', 'category_title', 'icon--toggle'];
                classes.forEach(className => {
                    const elements = document.getElementsByClassName(className);
                    for (const element of elements) {
                        if (element.hasAttribute('style')) {
                            element.removeAttribute('style');
                        }
                    }
                });
            } else {
                const classes = ['matching', 'topic_content', 'topic_title', 'category_content', 'category_title', 'icon--toggle'];
                classes.forEach(className => {
                    const elements = document.getElementsByClassName(className);
                    for (const element of elements) {
                        element.style.display = 'none';
                    }
                });

                el_data_text.forEach((element) => {
                    const data_text_value = element.getAttribute("data-text").toLowerCase();
                    if (data_text_value.includes(search_term)) {
                        const category = element.dataset.category;
                        const topic = element.dataset.topic;

                        const matching_topic = document.querySelectorAll(
                            '[data-topic="' + topic + '"]'
                        );
                        matching_topic.forEach((el) => {
                            if (el.classList.contains('topic_content')) {
                                el.style.display = "block";
                            }
                            if (el.classList.contains('topic_title')) {
                                el.style.display = "flex";
                            }
                        });

                        const matching_category = document.querySelectorAll(
                            '[data-category="' + category + '"]'
                        );
                        matching_category.forEach((el) => {
                            if (el.classList.contains('category_content')) {
                                el.style.display = "block";
                            }
                            if (el.classList.contains('category_title')) {
                                el.style.display = "flex";
                            }
                        });

                        element.style.display = "flex";
                    }
                });
            }

        });
    }
});